<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="400px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn fab color="error" dark v-bind="attrs" v-on="on">
        <v-icon>fas fa-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <!-- <v-card-title class="teal darken-3" dark>
        Register New Supplier
      </v-card-title> -->

      <v-toolbar dark color="teal darken-3">
        <v-toolbar-title>New Cost</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn text icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-5">
        <v-form ref="OtherCostForm">
          <v-text-field
            outlined
            shaped
            v-model.trim="OtherCost.CostName"
            :rules="[rules.required]"
            label="Cost Name"
            name="CostName"
          ></v-text-field>

          <v-text-field
            outlined
            shaped
            v-model.number="OtherCost.Contact"
            :rules="[rules.required]"
            type="number"
            label="Contact"
            id="SupplierPhone"
          ></v-text-field>
          <v-text-field
            outlined
            shaped
            v-model.number="OtherCost.Details"
            :rules="[rules.required]"
            label="Cost Details"
            id="SuppLierCountry"
          ></v-text-field>
          <v-select
            outlined
            shaped
            :items="GetCashTypes"
            v-model.number="OtherCost.CashType"
            :rules="[v => !!v || 'Cash Type is required']"
            label="Cash Type"
            required
            no-data-text="Refresh the page"
          ></v-select>

          <p class="font-weight-black mt-3 text-center" v-html="msgError"></p>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="isEditing"
          @click="CancelEdite"
          :loading="clicked"
          class="elevation-6"
          rounded
          color="error"
          dark
          width="150"
          >Cancel</v-btn
        >
        <v-spacer v-if="isEditing"></v-spacer>
        <v-btn
          :block="!isEditing"
          @click="UpdateOrSave"
          :loading="clicked"
          class="elevation-6"
          rounded
          color="teal darken-3"
          dark
          width="150"
          >{{ isEditing ? "Update" : "Save" }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    OnFinish: { type: Function, required: true },
    isEditing: { type: Boolean, required: true, default: false },
    OnEdite: { type: Object, required: true },
  },
  data() {
    return {
      ID: "",
      SuppURL: "/supplier/other",
      dialog: false,
      msgError: "",
      clicked: false,
      OtherCost: {
        CostName: "",
        Contact: "",
        Details: "",
        CashType: null,
      },
      rules: {
        required: value => !!value || "Required.",
      },
    };
  },
  computed: {
    ...mapGetters(["GetCashTypes"]),
  },
  watch: {
    isEditing(val) {
      if (val) {
        this.dialog = true;
        this.OnCostEdite(this.OnEdite);
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$refs.OtherCostForm.reset();
      this.$emit("input", false);
    },
    UpdateOrSave() {
      if (this.isEditing) this.OnCostUpdate();
      else this.OnCostSave();
    },
    CancelEdite() {
      //   this.isEditing = false;
      this.close();
      this.msgError = "";
      //   this.$refs.OtherCostForm.reset();
      this.ID = "";
    },
    OnCostUpdate() {
      // console.log("Updating");
      this.msgError = "";
      if (this.$refs.OtherCostForm.validate() && this.ID) {
        this.clicked = true;
        this.$store
          .dispatch("UPDATE_ONLY", {
            url: this.SuppURL,
            data: { ...this.OtherCost, ID: this.ID },
          })
          .then(result => {
            this.clicked = false;
            this.ID = "";
            this.OnFinish(result.data);
            this.close();
          })
          .catch(err => {
            this.clicked = false;
            if (err.response && err.response.data)
              this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
    OnCostSave() {
      this.msgError = "";
      if (this.$refs.OtherCostForm.validate()) {
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.SuppURL,
            data: this.OtherCost,
          })
          .then(result => {
            this.clicked = false;
            this.$refs.OtherCostForm.reset();
            // console.log(result);
            // this.AllSuppliers = result.data;
            this.OnFinish(result.data);
          })
          .catch(err => {
            this.clicked = false;
            this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
    OnCostEdite(E_Supp) {
      // console.log(E_Supp);
      this.ID = E_Supp._id;
      this.msgError = "";
      this.isEditing = true;
      this.OtherCost.CostName = E_Supp.CostName;
      this.OtherCost.Contact = E_Supp.Contact;
      this.OtherCost.Details = E_Supp.Details;
      this.OtherCost.CashType = E_Supp.CashType;
    },
  },
};
</script>
